import { __awaiter } from 'tslib';
import { IMEvent, InitResult } from '../../consts.js';
import { BaseProcessor } from './BaseProcessor.js';
import { im_proto } from '../../../proto/index.js';
import { Logger } from '../../metrics/logger.js';
import { ServiceIdentity } from '../RuntimeContext.js';

class ConversationLoader extends BaseProcessor {
    process(item) {
        return __awaiter(this, void 0, void 0, function* () {
            const conid = item.data.conversationId;
            if (!conid) {
                Logger.ctxWarn(this.ctx, 'no conversation provided in message, ignore', item.data);
                item.needContinue = false;
                return item;
            }
            const local = this.resolve(ServiceIdentity.ConversationManager).getRaw(conid);
            // 本地已经存在, 是一个解散命令
            // 不再处理后续
            if (item.data.type === im_proto.MessageType.MESSAGE_TYPE_CONVERSATION_DESTROY && local) {
                this.resolve(ServiceIdentity.ConversationManager).delete(conid);
                this.resolve(ServiceIdentity.EventBus).emit(IMEvent.ConversationDissolve, this, local);
                this.resolve(ServiceIdentity.EventBus).emitEmpty(IMEvent.ConversationChange, this);
                item.needContinue = false;
                return item;
            }
            // 本地不存在的会话, 如果消息不是普通消息, 那么不处理
            if (!item.data.isNormalMsg && local === undefined) {
                item.needContinue = false;
                if (this.ctx.initResult === InitResult.Succeeded) {
                    Logger.ctxDebug(this.ctx, `ignore process, conv: ${item.data.conversationId} not exist for cmd msg`, item.data);
                }
                return item;
            }
            const msg = item.data;
            const localConv = this.resolve(ServiceIdentity.ConversationManager).getWithCreateLocal(msg.conversationId, msg.conversationShortId, msg.conversationType);
            item.conv = localConv;
            return item;
        });
    }
}

export { ConversationLoader };
//# sourceMappingURL=ConversationLoader.js.map
